import './news-filter-app.css';
import { h } from 'preact';
import { useState, useCallback, useEffect } from 'preact/hooks';

import useFetchNewsItems from '../../utils/useFetchNewsItems';
import useFetchFilters from '../../utils/useFetchFilters';

import { getFiltersForModal, getActiveFilters, getUpdatedValue, isMatch } from '../../utils/filterHelpers';

//components
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import ViewFilterModal from '../ViewFilterModal/ViewFilterModal';
import ViewActiveFilters from '../ViewActiveFilters/ViewActiveFilters';
import ViewNewsItems from '../ViewNewsItems/ViewNewsItems';
import ViewMoreButton from '../ViewMoreButton/ViewMoreButton';

export default function NewsFilterApp({
	fetchNewsItemsUrl,
	fetchFiltersUrl
}){
	const fetchedNewsItems = useFetchNewsItems({ fetchNewsItemsUrl });
	const fetchedFilters = useFetchFilters({ fetchFiltersUrl });
	const [filters, setFilters] = useState([]);
	const [filterValues, setFilterValues] = useState([]);
	const [updateFilterValues, setUpdateFilterValues] = useState([]);
	const [newsitems, setNewsItems] = useState([]);
	const [activeNewsItems, setActiveNewsItems] = useState([]);
	const [isLoading, setLoading] = useState(true);
	const [focusNewsItem, setFocusNewsItem] = useState(false);

	useEffect(() => {
		if (Array.isArray(fetchedNewsItems) && Array.isArray(fetchedFilters)) {
			setFilters(fetchedFilters.map(filter => ({
				...filter,
			})));
			setNewsItems(fetchedNewsItems.slice(0, 3));
			setLoading(false);
		}
	}, [fetchedNewsItems, fetchedFilters]);

	useEffect(() => {
		if (filters.length === 0) {
			return;
		}

		//TODO: Standaard filter values uitlezen indien ingevuld.
		setFilterValues(filters.map(filter => ({
			name: filter.name,
			value: filter.defaultValue ? filter.defaultValue : null
		})));
	}, [filters]);

	const handleFilterChange = useCallback((name, value) => {
		setUpdateFilterValues(filterValues.map(filter => ({
			...filter,
			value: filter.name === name ? getUpdatedValue(name, value, filter.value) : filter.value
		})));
	}, [filterValues]);

	const applyFiltersHandler = useCallback(() => {
		setFilterValues(updateFilterValues);
	}, [updateFilterValues]);

	const handleFiltersReset = useCallback(() => {
		setFilterValues(filterValues.map(filter => ({
			...filter,
			value: null
		})));

	}, [filterValues]);

	const handleFilterReset = useCallback((filterName) => {
		setFilterValues(filterValues.map(filter => ({
			...filter,
			value: filter.name === filterName ? null : filter.value
		})));

	}, [filterValues]);

	const getMoreNewsItems = useCallback(() => {
		if (!Array.isArray(newsitems) || filters.length === 0) {
			return;
		}

		const newActiveNewsItems = newsitems.slice(0, (activeNewsItems.length + 3));

		setActiveNewsItems(newActiveNewsItems);
		setFocusNewsItem( newActiveNewsItems.length - 3 );

	}, [newsitems, activeNewsItems, filters.length]);

	useEffect(() => {
		if (!Array.isArray(fetchedNewsItems) || filters.length === 0) {
			return;
		}
		setNewsItems(fetchedNewsItems.filter(newsitem => filterValues.filter(filter => isMatch(filter.name, newsitem, filter.value)).length === filterValues.length));
	}, [filterValues]);

	useEffect(() => {
		if (!Array.isArray(newsitems) || filters.length === 0) {
			return;
		}

		setActiveNewsItems(newsitems.slice(0, 3));
	}, [newsitems]);

	return (
		isLoading ?
			<div class="news-filter-container">
				<LoadingSpinner />
			</div> :

			<div class="news-filter-container">
				<ViewFilterModal filters={getFiltersForModal(filters, updateFilterValues)} onFilterChangeHandler={handleFilterChange} onFiltersResetHandler={handleFiltersReset} applyFiltersHandler={applyFiltersHandler} />
				<ViewActiveFilters activeFilters={getActiveFilters(filters, filterValues)} onResetFilterHandler={handleFilterReset} />
				<ViewNewsItems newsitems={activeNewsItems} focusNewsItem={focusNewsItem} />
				{newsitems.length > activeNewsItems.length ?
					<ViewMoreButton getMoreNewsItemsHandler={getMoreNewsItems} /> : ''}
			</div>
	);
}
